import SettingTypes from '@/utils/setting-types'
import { platformType } from '@/utils/decor-types'

export default {
  name: 'book-videos',
  label: {
    title: '视频模块',
    icon: require('@/assets/icon-component-label_BookVideos.svg'),
    limit: -1,
    show: () => Number(platformType) === 1,
  },
  sort: 102,
  data: {
    books: [],
    // 背景颜色
    boxBackgroundColor: '#ffffff',
    videoTitleColor: '#3C4353',
    videoDescColor: '#A6AAB8',
    videoLineColor: '#e9e9e9',
  },
  settings: {
    boxBackgroundColor:{
      label: '模块背景颜色',
      type: SettingTypes.color_picker,
      default: '#ffffff'
    },
    videoLineColor: {
      type: SettingTypes.color_picker,
      label: '分割线颜色',
      default: '#e9e9e9'
    },
    videoTitleColor: {
      type: SettingTypes.color_picker,
      label: '标题颜色',
      default: '#3C4353'
    },
    videoDescColor: {
      type: SettingTypes.color_picker,
      label: '描述颜色',
      default: '#A6AAB8'
    },
    books: {
      type: SettingTypes.custom,
      component_name: 'BookVideosSelector'
    }
  }
}
